<template>
  <div class="nav-second-wrapper">
    <dna-wrapper>
      <div class="nav-second">
        <ul :class="type">
          <li
            v-for="(item, index) in dataSource"
            :key="index"
            @click="handle(item, index)"
            :class="{active:active == index}"
          >{{item.text}}</li>
        </ul>
      </div>
    </dna-wrapper>
  </div>
</template>

<script>
export default {
  props: {
    dataSource: {
      // 数据来源
      type: Array,
      default: () => {
        return [];
      }
    },
    currIndex: {
      // 当前处于第几个选项
      type: Number | String,
      default: () => {
        return 0;
      }
    },
    type: {
      // 组件类型，（可选）（可选值："default", "full")
      type: String,
      default: () => {
        return "default";
      }
    }
  },
  data() {
    return {
      active: "" // 当前处于第几个选项
    };
  },
  created() {
    this.active = this._props.currIndex; // 获取父组件的参数值
  },
  methods: {
    setActive(index) {
      this.active = index; // 设置当前选项
    },
    handle(item, index) {
      this.active = index; // 设置当前选项
      this.$emit("navSecondHandle", item, index); // 传值父组件
    }
  }
};
</script>

<style lang="less" scoped>
@import url("./NavSecond.less");
</style>
